import { type MouseEventHandler } from 'react';

import { IconButton, Stack, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';

export type CardHeaderIconAction = {
  label: string;
  icon: React.ReactNode;
  link?: { to: string; target?: '_blank' | '_self'; search?: string };
  onClick?: MouseEventHandler;
  disabled?: boolean;
};

export const iconButtonSx = {
  color: 'text.secondary',
  backgroundColor: 'action.hover',
  transition: 'all 0.15s ease',
  '&:hover': {
    backgroundColor: 'action.selected',
  },
};

const getActionButtonProps = (action: CardHeaderIconAction) => {
  if (action.link) {
    return {
      component: Link,
      to:
        action.link.search != null
          ? { pathname: action.link.to, search: action.link.search }
          : action.link.to,
      target: action.link.target ?? '_self',
    };
  }

  return { onClick: action.onClick };
};

type CardHeaderIconActionsProps = {
  actions: CardHeaderIconAction[];
};

export const CardHeaderIconActions = ({
  actions,
}: CardHeaderIconActionsProps) => (
  <Stack direction="row" sx={{ gap: 0.5 }}>
    {actions.map((action, index) => (
      <Tooltip key={index} title={action.label}>
        <span>
          <IconButton
            aria-label={action.label}
            size="small"
            disabled={action.disabled}
            sx={iconButtonSx}
            {...getActionButtonProps(action)}
          >
            {action.icon}
          </IconButton>
        </span>
      </Tooltip>
    ))}
  </Stack>
);
